import React, { useEffect, useState } from 'react';

const Typewriter = ({
  words = [],
  typingSpeed = 70,
  deletingSpeed = 40,
  pauseTime = 1400,
  className = '',
}) => {
  const [index, setIndex] = useState(0);
  const [sub, setSub] = useState('');
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!words.length) return;
    const current = words[index % words.length];

    if (!deleting && sub === current) {
      const t = setTimeout(() => setDeleting(true), pauseTime);
      return () => clearTimeout(t);
    }
    if (deleting && sub === '') {
      setDeleting(false);
      setIndex((i) => (i + 1) % words.length);
      return;
    }

    const t = setTimeout(
      () => {
        setSub((s) =>
          deleting ? current.substring(0, s.length - 1) : current.substring(0, s.length + 1)
        );
      },
      deleting ? deletingSpeed : typingSpeed
    );
    return () => clearTimeout(t);
  }, [sub, deleting, index, words, typingSpeed, deletingSpeed, pauseTime]);

  return (
    <span className={className} data-testid="typewriter-text">
      {sub}
      <span className="typewriter-cursor" aria-hidden="true">&nbsp;</span>
    </span>
  );
};

export default Typewriter;
